/* src/app/reporting/pages/reporting/reporting.component.scss */
label {
  margin: 0;
  font-weight: bold;
}
input {
  border-bottom: 1px solid black;
  padding: 0;
}
/*# sourceMappingURL=reporting.component.css.map */
